<template>
  <div style="max-width: 100%;">
    
    <BGVideo />
    <Navs />
    
    <div style="top: 0px; position: relative;">
      <router-view></router-view>
      

    </div>
    <br><br> <br>
    <div style="bottom: 0px; position: fixed; text-align: center; width: 100%;">
      <div style="width: 90%; max-width: 300px;" id="shakleePlugin"></div>
        <span style="color: white; font-size: 12px;">
          &copy; A Copyright Coastal 5k LLC 2021-{{new Date().getFullYear()}}
        </span>
    </div>

  </div>
</template>

<script>
import BGVideo from './views/BGVideo.vue'
import Navs from './views/Navs.vue'

export default {
  data () {
    return {

    }
  },
  computed: {
    getCurrentRoutePath() {
      return this.$router.currentRoute.path
    }
  },
  components: {
    BGVideo, Navs
  },
  methods: {
      changeRoute(to) {
          
          let pathSplit = to.path.split('/')
          
          if(pathSplit[pathSplit.length-1]) {
            this.$store.getters.getMasterDB.forEach(element => {
              if(element.url == pathSplit[pathSplit.length-1]) {
                this.$store.commit('setRefCompany', element)
              }
            })
          }
          
          window.scroll(0, 0)
          
      }

  },
  created() {
    let masterDB = require('../db.json')
    this.$store.commit('setMasterDB', (masterDB))

    setTimeout(() => {
      this.changeRoute(this.$route)    
    }, 300);

  },
  mounted() {
    //this.changeRoute(this.$route)
  },
  watch: {
      '$route' (to) {
        this.changeRoute(to)
      }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue